import type { FaireProductEntity } from "../../entity_types/product";

export const p_ucvkbtzvre: FaireProductEntity = {
  token: "p_ucvkbtzvre",
  type: "product",
  name: "U-Hug Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/362aa268c6220d733654c4fa100cdca20b4276aa8e0809081bcf93e9203ec3b8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8b52e90ad77c76f7a43d96b0343293f149286ab25cea638a40f8989a109ad169.jpeg",
    "https://cdn.faire.com/fastly/46028691c7db88a5391ef7ca383d4264ec0458353a605834a81dd73c775175af.jpeg",
  ],
  priceDollars: 3,
  description:
    "When your vehicle can't fit the amount of love and hugs you want to bring... UHUG. Your hug delivery resource.",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:39.207Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
